export const DESIGN = ({ ...props }) => {
  return (
    <svg
      {...props}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="56" height="56" rx="8" fill="#0084FF" fillOpacity="0.05" />
      <rect
        x="0.666477"
        y="0.666477"
        width="54.667"
        height="54.667"
        rx="7.33352"
        stroke="#0084FF"
        strokeOpacity="0.15"
        strokeWidth="1.33295"
      />
      <path
        d="M23.9257 29.6196L24.5886 30.2825L23.9257 29.6196ZM26.2827 29.6196L26.9456 28.9566L26.2827 29.6196ZM23.2292 22.5035H33.6458V20.6285H23.2292V22.5035ZM34.375 23.2327V33.6494H36.25V23.2327H34.375ZM22.2254 32.6456L24.5886 30.2825L23.2627 28.9566L20.8996 31.3198L22.2254 32.6456ZM22.5 33.6494V31.9827H20.625V33.6494H22.5ZM22.5 31.9827V23.2327H20.625V31.9827H22.5ZM25.6198 30.2825L31.3163 35.979L32.6421 34.6531L26.9456 28.9566L25.6198 30.2825ZM33.6458 34.3785H31.9792V36.2535H33.6458V34.3785ZM31.9792 34.3785H23.2292V36.2535H31.9792V34.3785ZM24.5886 30.2825C24.8733 29.9977 25.335 29.9977 25.6198 30.2825L26.9456 28.9566C25.9286 27.9396 24.2797 27.9396 23.2627 28.9566L24.5886 30.2825ZM20.625 33.6494C20.625 35.0876 21.7909 36.2535 23.2292 36.2535V34.3785C22.8265 34.3785 22.5 34.0521 22.5 33.6494H20.625ZM34.375 33.6494C34.375 34.0521 34.0485 34.3785 33.6458 34.3785V36.2535C35.0841 36.2535 36.25 35.0876 36.25 33.6494H34.375ZM33.6458 22.5035C34.0485 22.5035 34.375 22.83 34.375 23.2327H36.25C36.25 21.7945 35.0841 20.6285 33.6458 20.6285V22.5035ZM23.2292 20.6285C21.7909 20.6285 20.625 21.7945 20.625 23.2327H22.5C22.5 22.83 22.8265 22.5035 23.2292 22.5035V20.6285ZM31.25 26.3577C31.25 26.7604 30.9235 27.0869 30.5208 27.0869V28.9619C31.9591 28.9619 33.125 27.7959 33.125 26.3577H31.25ZM30.5208 27.0869C30.1181 27.0869 29.7917 26.7604 29.7917 26.3577H27.9167C27.9167 27.7959 29.0826 28.9619 30.5208 28.9619V27.0869ZM29.7917 26.3577C29.7917 25.955 30.1181 25.6285 30.5208 25.6285V23.7535C29.0826 23.7535 27.9167 24.9195 27.9167 26.3577H29.7917ZM30.5208 25.6285C30.9235 25.6285 31.25 25.955 31.25 26.3577H33.125C33.125 24.9195 31.9591 23.7535 30.5208 23.7535V25.6285Z"
        fill="#0084FF"
      />
    </svg>
  );
};
